// frontend/src/themes/decor/fonts.js
// @font-face das fontes de título self-hosted (OFL). Montado uma vez no App.
import React from "react";
import { GlobalStyles } from "@mui/material";
import quicksand600 from "../assets/fonts/quicksand-600.woff2";
import quicksand700 from "../assets/fonts/quicksand-700.woff2";
import orbitron600 from "../assets/fonts/orbitron-600.woff2";

const faces = `
@font-face { font-family: 'Quicksand'; font-style: normal; font-weight: 600; font-display: swap; src: url(${quicksand600}) format('woff2'); }
@font-face { font-family: 'Quicksand'; font-style: normal; font-weight: 700; font-display: swap; src: url(${quicksand700}) format('woff2'); }
@font-face { font-family: 'Orbitron'; font-style: normal; font-weight: 600; font-display: swap; src: url(${orbitron600}) format('woff2'); }
`;

const ThemeFonts = () => <GlobalStyles styles={faces} />;
export default ThemeFonts;
